import styled from '@emotion/styled';
import { getSpacing } from '@cabonline/ui-shared';

export const StyledFormGroup = styled.div`
  margin-bottom: ${getSpacing('m')};
`;
